import { useEffect, useState } from "react";
import { useCookieConsentStore } from "../../stores/useCookieConsentStore";

function CookieConsentBanner() {
    const cookieConsent = useCookieConsentStore((state) => state.getCookieConsent());
    const showBanner = useCookieConsentStore((state) => state.showBanner);

    const handleAccept = async () => {
        useCookieConsentStore.getState().setCookieConsent(true);
    }

    const handleDecline = async () => {
        useCookieConsentStore.getState().setCookieConsent(false);
    }

    return (
        <>
            {showBanner &&
                <div className="notification is-success is-light is-fixed-bottom" style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    margin: 0,
                    borderRadius: 0
                }}>
                    <div className="container">
                        <div>
                            <p>
                                <div className="is-size=5 has-text-weight-bold">Cookie Consent</div>
                                <div>
                                    <span className="has-text-weight-strong">Necessary:</span> To remember your choice on this banner, our site
                                    uses essential storage in your browser. We do not set any other first-party cookies.
                                </div>
                                <div className="mt-2">
                                    <span className="has-text-weight-strong">Third Party:</span> To enable Sign In With Google we need your
                                    consent to allow third parties (Google) to set cookies. As an alternative, you can sign in using email and password.
                                </div>
                                <div>
                                    You can learn more in our <a href="/privacy">Privacy Policy</a>.
                                </div>
                            </p>
                        </div>
                        <div className="columns is-vcentered mb-5 mt-3">
                            <div className="column is-narrow">
                                <div className="buttons">
                                    <button
                                        className="button is-primary is-small"
                                        onClick={handleAccept}
                                    >
                                        Allow Third Party
                                    </button>
                                    <button
                                        className="button is-dark is-outlined is-small"
                                        onClick={handleDecline}
                                    >
                                        Decline
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default CookieConsentBanner;